<pdf-viewer [src]="pdf"
[render-text]="true"
[original-size]="false"
style="width: 700px; height: 800px"
></pdf-viewer>

